export default "__VITE_ASSET__CMLieWAi__"